import { WorldCountry } from '../types';

export const algeriaData: WorldCountry = {
  code: 'DZ',
  name: 'Algeria',
  slug: 'algeria',
  population: 43851044,
  topCities: [
    { name: 'Algiers', slug: 'algiers', population: 3415811 },
    { name: 'Oran', slug: 'oran', population: 1454078 },
    { name: 'Constantine', slug: 'constantine', population: 938475 },
    { name: 'Annaba', slug: 'annaba', population: 464740 },
    { name: 'Blida', slug: 'blida', population: 331779 },
    { name: 'Batna', slug: 'batna', population: 290645 },
    { name: 'Djelfa', slug: 'djelfa', population: 287455 },
    { name: 'Setif', slug: 'setif', population: 288461 },
    { name: 'Sidi Bel Abbes', slug: 'sidi-bel-abbes', population: 210146 },
    { name: 'Biskra', slug: 'biskra', population: 307987 },
    { name: 'Tebessa', slug: 'tebessa', population: 196537 },
    { name: 'El Oued', slug: 'el-oued', population: 174469 },
    { name: 'Skikda', slug: 'skikda', population: 186747 },
    { name: 'Tiaret', slug: 'tiaret', population: 166349 },
    { name: 'Bejaia', slug: 'bejaia', population: 177988 },
    { name: 'Tlemcen', slug: 'tlemcen', population: 140158 },
    { name: 'Ouargla', slug: 'ouargla', population: 190558 },
    { name: 'Bechar', slug: 'bechar', population: 165627 },
    { name: 'Mostaganem', slug: 'mostaganem', population: 145696 },
    { name: 'Bordj Bou Arreridj', slug: 'bordj-bou-arreridj', population: 168346 },
    { name: 'Chlef', slug: 'chlef', population: 178616 },
    { name: 'Medea', slug: 'medea', population: 123535 },
    { name: 'Tizi Ouzou', slug: 'tizi-ouzou', population: 144000 },
    { name: 'Mascara', slug: 'mascara', population: 150000 },
    { name: 'Oum El Bouaghi', slug: 'oum-el-bouaghi', population: 88853 },
    { name: 'Laghouat', slug: 'laghouat', population: 134372 },
    { name: 'Khenchela', slug: 'khenchela', population: 100000 },
    { name: 'Souk Ahras', slug: 'souk-ahras', population: 115000 },
    { name: 'Guelma', slug: 'guelma', population: 123590 },
    { name: 'Jijel', slug: 'jijel', population: 131513 },
    { name: 'Relizane', slug: 'relizane', population: 130094 },
    { name: 'M\'Sila', slug: 'msila', population: 156647 },
    { name: 'El Tarf', slug: 'el-tarf', population: 44248 },
    { name: 'Tissemsilt', slug: 'tissemsilt', population: 61155 },
    { name: 'El Bayadh', slug: 'el-bayadh', population: 72189 },
    { name: 'Naama', slug: 'naama', population: 12177 },
    { name: 'Ain Defla', slug: 'ain-defla', population: 52000 },
    { name: 'Ain Temouchent', slug: 'ain-temouchent', population: 65518 },
    { name: 'Ghardaia', slug: 'ghardaia', population: 93423 },
    { name: 'Illizi', slug: 'illizi', population: 10000 },
    { name: 'Bouira', slug: 'bouira', population: 75707 },
    { name: 'Boumerdes', slug: 'boumerdes', population: 35934 },
    { name: 'Tipaza', slug: 'tipaza', population: 27553 },
    { name: 'Mila', slug: 'mila', population: 69052 },
    { name: 'Adrar', slug: 'adrar', population: 64781 },
    { name: 'Tamanghasset', slug: 'tamanghasset', population: 92635 },
    { name: 'Tindouf', slug: 'tindouf', population: 49000 },
    { name: 'Saida', slug: 'saida', population: 128500 },
    { name: 'Aflou', slug: 'aflou', population: 53260 },
    { name: 'Ain Sefra', slug: 'ain-sefra', population: 47415 },
    { name: 'Touggourt', slug: 'touggourt', population: 39409 },
    { name: 'Hassi Messaoud', slug: 'hassi-messaoud', population: 45000 },
    { name: 'Rouiba', slug: 'rouiba', population: 61934 },
    { name: 'Reghaia', slug: 'reghaia', population: 58923 },
    { name: 'Bordj El Kiffan', slug: 'bordj-el-kiffan', population: 103690 },
    { name: 'Draria', slug: 'draria', population: 23050 },
    { name: 'Zeralda', slug: 'zeralda', population: 33047 },
    { name: 'Douera', slug: 'douera', population: 41804 },
    { name: 'Kolea', slug: 'kolea', population: 46158 },
    { name: 'Cheraga', slug: 'cheraga', population: 60295 },
    { name: 'Dely Ibrahim', slug: 'dely-ibrahim', population: 30576 },
    { name: 'El Achour', slug: 'el-achour', population: 19524 },
    { name: 'Bouzareah', slug: 'bouzareah', population: 69153 },
    { name: 'Bab Ezzouar', slug: 'bab-ezzouar', population: 92157 },
    { name: 'Hussein Dey', slug: 'hussein-dey', population: 49921 },
    { name: 'Kouba', slug: 'kouba', population: 105253 },
    { name: 'Bourouba', slug: 'bourouba', population: 77498 },
    { name: 'El Mouradia', slug: 'el-mouradia', population: 29503 },
    { name: 'Hydra', slug: 'hydra', population: 35727 },
    { name: 'Mohammadia', slug: 'mohammadia', population: 54839 },
    { name: 'Bordj El Bahri', slug: 'bordj-el-bahri', population: 27905 },
    { name: 'El Marsa', slug: 'el-marsa', population: 5893 },
    { name: 'Sidi Moussa', slug: 'sidi-moussa', population: 6381 },
    { name: 'Staoueli', slug: 'staoueli', population: 38915 },
    { name: 'Saoula', slug: 'saoula', population: 31388 },
    { name: 'Birtouta', slug: 'birtouta', population: 30576 },
    { name: 'Tessala El Merdja', slug: 'tessala-el-merdja', population: 10792 },
    { name: 'Ouled Chebel', slug: 'ouled-chebel', population: 2293 },
    { name: 'Sidi Abdellah', slug: 'sidi-abdellah', population: 14435 },
    { name: 'Fouka', slug: 'fouka', population: 18061 },
    { name: 'Bouinan', slug: 'bouinan', population: 24871 },
    { name: 'Soumaa', slug: 'soumaa', population: 31388 },
    { name: 'Chebli', slug: 'chebli', population: 21506 },
    { name: 'El Affroun', slug: 'el-affroun', population: 37602 },
    { name: 'Mouzaia', slug: 'mouzaia', population: 44893 },
    { name: 'Boufarik', slug: 'boufarik', population: 57162 },
    { name: 'Larbaa', slug: 'larbaa', population: 60482 },
    { name: 'Oued Alleug', slug: 'oued-alleug', population: 8835 },
    { name: 'Chrea', slug: 'chrea', population: 21667 },
    { name: 'Beni Mered', slug: 'beni-mered', population: 21457 },
    { name: 'Bouarfa', slug: 'bouarfa', population: 25983 },
    { name: 'Ben Khellil', slug: 'ben-khellil', population: 4251 },
    { name: 'Oued El Alleug', slug: 'oued-el-alleug', population: 8835 },
    { name: 'Ouled Yaich', slug: 'ouled-yaich', population: 55719 },
    { name: 'Guerrouaou', slug: 'guerrouaou', population: 15306 },
    { name: 'Hammam Melouane', slug: 'hammam-melouane', population: 4551 },
    { name: 'Ain Romana', slug: 'ain-romana', population: 4882 },
    { name: 'Djebabra', slug: 'djebabra', population: 4468 },
    { name: 'Halhal', slug: 'halhal', population: 4432 },
    { name: 'Ridane', slug: 'ridane', population: 3029 },
    { name: 'Bougara', slug: 'bougara', population: 34100 },
    { name: 'Ben Chaoud', slug: 'ben-chaoud', population: 7251 },
    { name: 'Chiffa', slug: 'chiffa', population: 26886 },
    { name: 'Hammam Righa', slug: 'hammam-righa', population: 7133 },
    { name: 'Ain Defla Center', slug: 'ain-defla-center', population: 52000 },
    { name: 'Khemis Miliana', slug: 'khemis-miliana', population: 74349 },
    // Nuevas ciudades para Algeria - Expansión hacia 100 ciudades
    { name: 'Sour El Ghozlane', slug: 'sour-el-ghozlane', population: 42000 },
    { name: 'Ksar El Boukhari', slug: 'ksar-el-boukhari', population: 38000 },
    { name: 'Berberossa', slug: 'berberossa', population: 35000 },
    { name: 'Ouamri', slug: 'ouamri', population: 32000 },
    { name: 'Tablat', slug: 'tablat', population: 29000 },
    { name: 'Derrag', slug: 'derrag', population: 26000 },
    { name: 'Sedraya', slug: 'sedraya', population: 23000 },
    { name: 'Aziz', slug: 'aziz', population: 20000 },
    { name: 'Boghar', slug: 'boghar', population: 18000 },
    { name: 'Chelghoum Laid', slug: 'chelghoum-laid', population: 16000 }
  ]
};
